const BASE_PATH = '/configure/area'

export default {
  getList: () => ({
    url: BASE_PATH,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/apis/modules/Area.js